export default "__VITE_ASSET__$Phf$SLN__"